var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconStarFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4374 1.79541C15.8086 1.06816 16.8477 1.06816 17.2188 1.79541L21.193 9.58275C21.3383 9.86747 21.6109 10.0656 21.9266 10.1158L30.5609 11.489C31.3673 11.6172 31.6884 12.6055 31.1114 13.1832L24.9333 19.3693C24.7074 19.5955 24.6032 19.916 24.653 20.2317L26.0152 28.8678C26.1424 29.6743 25.3017 30.2851 24.574 29.9149L16.7815 25.9507C16.4966 25.8058 16.1596 25.8058 15.8747 25.9507L8.08227 29.9149C7.35455 30.2851 6.51386 29.6743 6.64107 28.8678L8.00321 20.2317C8.05301 19.916 7.94886 19.5955 7.72298 19.3693L1.54485 13.1832C0.967884 12.6055 1.289 11.6172 2.09535 11.489L10.7296 10.1158C11.0453 10.0656 11.318 9.86747 11.4633 9.58275L15.4374 1.79541Z",
    fill: "#02283D",
    stroke: "#02283D",
    strokeWidth: 2.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStarFilled);
export default __webpack_public_path__ + "static/media/icon_star_filled.8c02f47c1fbfb6a25445aeb3e3014988.svg";
export { ForwardRef as ReactComponent };